export default __webpack_public_path__ + "static/media/liederland-swissmom-special.e8cb80f8.pdf";